import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreOAuthLogin',
  data: function data() {
    return {
      clients: [],
      rememberUser: false
    };
  },
  watch: {
    rememberUser: function rememberUser() {
      if (this.rememberUser) {
        this.clients = this.clients.map(function (client) {
          client.redirectURI = client.redirectURI.replace('access_type=online', 'access_type=offline');
          return client;
        });
        this.clients = cloneDeep(this.clients);
        return;
      }

      this.clients = this.clients.map(function (client) {
        client.redirectURI = client.redirectURI.replace('access_type=offline', 'access_type=online');
        return client;
      });
      this.clients = cloneDeep(this.clients);
    }
  },
  mounted: function mounted() {
    this.loadOauthClients();
  },
  methods: {
    loadOauthClients: function loadOauthClients() {
      var _this = this;

      return ApiService.getOAuthClientsForURI(window.location.host, window.location.origin, this.$route.query.oauthClient).then(function (clients) {
        _this.clients = clients || [];
      });
    }
  }
};